import { Operando } from "./Operando";
import { TipoCondicionEnum } from "@shared/enums";
import { Observable, Subject } from "rxjs";

export class Condicion implements Operando {
    public borrar$: Observable<void>;
    public data: string;
    private _borrar$ = new Subject<void>();

    constructor(public tipo: TipoCondicionEnum, public nombre = "",
        public esLaCondicion: (condicion: string) => boolean) {
        this.borrar$ = this._borrar$.asObservable();
    }

    public borrar() {
        this._borrar$.next();
    }

    public formateado() {
        return this.data;
    }

    public clone(): Condicion {
        return new Condicion(this.tipo, this.nombre, this.esLaCondicion);
    }
}
